var _defs, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _circle, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 95.1 104.3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-310.9-675.4a2 2 0 0 1 2-2h36.2a2 2 0 0 1 2 2v31.8a2 2 0 0 1-2 2h-36.2a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.2-684.5h6.7v11.94h-6.7z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-284-684.5h6.7v11.94h-6.7z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.2-667.8h26.8v7.17h-26.8z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.2-655.9h26.8v7.17h-26.8z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none}.cls-8{fill:#fff}.cls-9{fill:#d1d3d4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 6.7h25a10.6 10.6 0 0 1 10.6 10.6v73.1a6.9 6.9 0 0 1-6.9 6.9H14a6.9 6.9 0 0 1-6.9-6.9V17.3A10.6 10.6 0 0 1 17.7 6.7",
    className: "cls-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 98.3H14a7.9 7.9 0 0 1-7.9-7.9V17.3A11.6 11.6 0 0 1 17.7 5.7h25a11.6 11.6 0 0 1 11.6 11.6v73.1a7.9 7.9 0 0 1-7.9 7.9M17.7 7.7a9.6 9.6 0 0 0-9.6 9.6v73.1a5.9 5.9 0 0 0 5.9 5.9h32.4a5.9 5.9 0 0 0 5.9-5.9V17.3a9.6 9.6 0 0 0-9.6-9.6z",
    className: "cls-9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f2f2",
    d: "M11.9 17.7h36.6v65.39H11.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 84.1H11.9a1 1 0 0 1-1-1V17.7a1 1 0 0 1 1-1h36.6a1 1 0 0 1 1 1v65.4a1 1 0 0 1-1 1m-35.6-2h34.6V18.7H12.9z",
    className: "cls-9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6fffb",
    d: "M24.7 11.5h10.7v1.08H24.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.7,
    height: 3.08,
    x: 23.7,
    y: 10.5,
    className: "cls-9",
    rx: 1,
    ry: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7fafc",
    d: "M38.5 44.6c3 1.3 4.1-.1 4.1-.1h-.5v-4.4h45v18h-45v-6.4c-3-1.4-3.6-7.1-3.6-7.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007faf",
    d: "M87.1 59.1h-45a1 1 0 0 1-1-1v-5.8c-2.9-1.9-3.5-7-3.6-7.6a1 1 0 0 1 1.4-1 4.2 4.2 0 0 0 2.2.4v-4a1 1 0 0 1 1-1h45a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-44-2h43v-16h-43v2.5a1 1 0 0 1 .4 1 .9.9 0 0 1-.3.5 3.8 3.8 0 0 1-3.5.8c.4 1.8 1.3 4.1 2.8 4.8a1 1 0 0 1 .6.9V57z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.6h36.6v4.83H12z",
    className: "cls-8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 23.5H12a1 1 0 0 1-1-1v-4.9a1 1 0 0 1 1-1h36.6a1 1 0 0 1 1 1v4.8a1 1 0 0 1-1 1.1m-35.6-2h34.6v-2.9H13v2.8z",
    className: "cls-9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3,
    cy: 90,
    r: 3,
    fill: "#e6e7e8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 94a4 4 0 1 1 4-4 4 4 0 0 1-4 4m0-6.1a2 2 0 1 0 2 2 2 2 0 0 0-2-1.9z",
    className: "cls-9"
  })));
};
export default SvgPhone;